import React, {useContext, useEffect, useState} from 'react';
import {currentMunicipalityInterface} from "../../App";
import Sidebar from "../Sidebar/Sidebar";
import Alertnotes from "../../components/Alerts/Alertnotes"
import {Alert, Container} from "@mui/material";
import Typography from "@mui/material/Typography";
import Heroband from "../../components/Hero/Hero";
import CurrentUserContext from "../../context/CurrentUserContext";
import Apicall from "../../libs/Apicall";
import { couleurs } from "../../theme/tokens";
import { brandingUrl } from "../../libs/branding";

interface propsInterface {
    municipality: currentMunicipalityInterface
}

interface userInterface {
    id: number;
    created_at: string;
    firstname: string;
    lastname: string;
    email: string;
    role: string;
}

interface AlertInterface {
    id: number;
    title: string;
    end_date: Date;
    description: string;
    url: string;
    uuid: string;
    type: string;
}

export default function Homepage({municipality}: propsInterface) {

    const [error, setError] = useState('');
    const [alerts, setAlerts] = useState<AlertInterface[]>([]);
    const [liftedAlerts, setLiftedAlerts] = useState<AlertInterface[]>([]);
    const [alertIcons,setAlertIcons] = useState<Record<string, any>>({});

    const currentuser:userInterface = useContext(CurrentUserContext) as userInterface;

    useEffect(() => {
        // Toujours la liste publique (toutes les alertes en vigueur de la
        // ville), connecté ou non : les préférences d'un citoyen (types
        // auxquels il est abonné) ne concernent que les canaux d'envoi
        // (SMS/courriel/appel/push), jamais ce qui s'affiche ici — sinon un
        // citoyen abonné à aucun type ne voyait plus aucune alerte en
        // vigueur en visitant le site, ce qui n'est pas voulu.
        const apicall = new Apicall();
        apicall.call('POST', 'public/alerts-for-public-dashboard', {city_id: municipality.id}).then((response) => {
            if(response.status === 'OK') {
                setAlerts(response.data.alerts);
                setLiftedAlerts(response.data.lifted_alerts);
                setAlertIcons(response.data.icons);
            }else{
                setError(String(response.error));
            }
        });
    }, []);

    return (
        <Sidebar title={'Page '+municipality.default_city_name} currentuser={currentuser} municipality={municipality}>
                <Heroband image={brandingUrl(municipality.splash_background)}/>
                <Container className={'head-content'} sx={{ maxWidth:{xl:'1680px'} }}>
                    {/* Espace réduit de moitié entre la photo et ce titre (demande explicite) : 34px -> 17px. */}
                    <Typography variant={'h3'} className='page-title' sx={{ color:couleurs.BleuClair, mb:'21.5px', mt:'17px' }}>Alertes en vigueur</Typography>
                </Container>

                {/* Espace au-dessus de « Alertes levées » divisé par 3 (demande explicite) : 50%/10% -> 16.67%/3.33%. */}
                <Container className={'alert-container'} sx={{ mb:{xs:'16.67%', sm:'3.33%'}, maxWidth:{xl:'1680px'} }}>
                    {
                        error &&
                        <Alert variant={'outlined'} severity={'error'} sx={{mx: 10}}>{error}</Alert>
                    }
                    {alerts.length === 0 ? (
                        <Typography variant="h6">Aucune alerte pour le moment.</Typography>
                    ) : (
                        alerts.map((alert, index) => (
                            <Alertnotes
                                key={index}
                                title={alert.title}
                                date={`Levée prévue le ${new Date(alert.end_date).toLocaleDateString('fr-FR')}`}
                                message={alert.description}
                                // Lien RELATIF (pas alert.url, absolu et
                                // codé en dur vers liencitoyen.com) : reste
                                // dans le site tel qu'il est actuellement
                                // servi (local, aperçu, prod…) au lieu d'en
                                // sortir vers un autre environnement.
                                link={`/alerte/${alert.uuid}`}
                                icon={alertIcons[alert.type] || ''}
                            />
                        ))
                    )}
                </Container>

                <Container className={'head-content'} sx={{ maxWidth:{xl:'1680px'} }}>
                    {/* Espace au-dessus de ce titre divisé par 3 en plus (demande explicite) : 17px -> 5.67px. */}
                    <Typography variant={'h3'} className='page-title' sx={{ color:couleurs.BleuClair, mb:'21.5px', mt:'5.67px' }}>Alertes levées</Typography>
                </Container>

                <Container className={'alert-container'} sx={{ mb:{xs:'50%', sm:'10%'}, maxWidth:{xl:'1680px'} }}>
                    {liftedAlerts.length === 0 ? (
                        <Typography variant="h6">Aucune alerte levée pour l'instant.</Typography>
                    ) : (
                        liftedAlerts.map((alert, index) => (
                            <Alertnotes
                                key={index}
                                title={alert.title}
                                date={`Levée le ${new Date(alert.end_date).toLocaleDateString('fr-FR')}`}
                                message={alert.description}
                                link={`/alerte/${alert.uuid}`}
                                icon={alertIcons[alert.type] || ''}
                                showActions={false}
                            />
                        ))
                    )}
                </Container>
        </Sidebar>


    );
}
